import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

/** Handling User Action Events, clicking from Emails to fire an action **/

@Injectable()
export class UserActionService {
  baseHref = `${environment.apiUrl}/user-actions`;

  constructor(private http: HttpClient) {}

  executeUserAction(token: string): Observable<any> {
    const url = `${this.baseHref}/${token}`;
    return this.http.get(url);
  }
}
